// src/features/auth/login/services/loginService.ts

import {
  AUTH_ENDPOINTS,
} from '../../../../api';

import api from '../../../../api/axios';

import type {
  LoginRequest,
} from '../types/login.types';


export const loginService = {

  /**
   * =========================================================
   * 로그인
   * =========================================================
   *
   * 로그인 성공 시
   * accessToken / refreshToken 등의
   * 인증 토큰을 반환합니다.
   */
  async login(
    data: LoginRequest,
  ) {

    return api.post(
      AUTH_ENDPOINTS.LOGIN,
      data,
    );
  },


  /**
   * =========================================================
   * 토큰 재발급
   * =========================================================
   *
   * 자동 로그인 및
   * accessToken 만료 시 사용합니다.
   *
   * 백엔드:
   *
   * POST
   * /api/v2/auth/refresh
   *
   * Request:
   *
   * {
   *   refreshToken: "..."
   * }
   *
   * Response:
   *
   * {
   *   code: "AUTH-200",
   *   message: "토큰 재발급 성공",
   *   data: {
   *     accessToken: "...",
   *     refreshToken: "...",
   *     tokenType: "Bearer",
   *     accessTokenExpiresIn: ...
   *   }
   * }
   *
   * Refresh Token Rotation을 사용하므로
   * 응답으로 받은 새로운 refreshToken을
   * 반드시 저장해야 합니다.
   * =========================================================
   */
  async refresh(
    refreshToken: string,
  ) {

    return api.post(
      AUTH_ENDPOINTS.REFRESH,
      {
        refreshToken,
      },
    );
  },


  /**
   * =========================================================
   * 로그아웃
   * =========================================================
   */
  async logout():
    Promise<void> {

    await api.post(
      AUTH_ENDPOINTS.LOGOUT,
    );
  },
};